module.exports = __webpack_public_path__ + "static/sofiapro-900-1aa93b552040a0bfe8bfa69b7350d7b4.woff";